

import React, { useRef } from 'react';
import { useState } from 'react';
//import './ContactForm.css';
import '../styles-contact-form.css';
import emailjs from '@emailjs/browser';

// include validate.JS to validate our form. - npm install validate.js
import validate from 'validate.js';


export function ContactForm_JS(){

  const form = useRef();
// =====================================//
// VALIDATE >>>>
// =====================================//
// uses Valiidate.js
//Real-time Validation: To validate as the user types, call validate() inside your onChange handler instead of just at onSubmit.


// set your rules
const constraints = {
  name: {
    presence: { allowEmpty: false, message: "is required" },
    length: { minimum: 2 }
  },
  phone: {
    presence: { allowEmpty: false, message: "is required" },
    format: {
      // Example regex for: (123) 456-7890, 123-456-7890, or 1234567890
      pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
      message: "must be a valid 10-digit number"
    }
  },
  email: {
    presence: { allowEmpty: false, message: "is required" },
    email: { message: "is not a valid email" }
  },
  message: {
    presence: { allowEmpty: false, message: "is required" },
    length: { minimum: 6 }
  }
};


  const [formData, setFormData] = useState({ name: '', phone: '', email: '', message: '' });
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // validate() returns an object of errors if invalid, or undefined if valid
    const validationErrors = validate(formData, constraints);
    
    if (validationErrors) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      console.log("Form is valid!", formData);
      // its valid dude! Send that shit!
      sendEmail();
    }
  };



       


// =====================================//
  // SEND EMAIL >>>>
// =====================================//
// Uses Email.JS

  const sendEmail = (e) => {
   // e.preventDefault();

    emailjs
      .sendForm('service_f8xs8cm', 'template_hhy1e6a', form.current, {
        publicKey: 'NUhu8pN8eHhQADIuG',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          document.querySelector(".form-sent-notice").style.display="block";
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (


   // <form className="contact_form" ref={form} onSubmit={sendEmail}>
<form className="contact_form" ref={form} onSubmit={handleSubmit} noValidate>

    <div className="flex-columns"> 

     <div className="col-50">
      <label>Name</label>
      <input  id="name" type="text" name="name" onChange={(e) => setFormData({...formData, name: e.target.value})} />
      </div>

       <div className="col-50">
      <label>Phone</label>
      <input id="phone" type="tel" name="phone" onChange={(e) => setFormData({...formData, phone: e.target.value})} />
      </div>

      </div>

      <label>Email</label>
      <input id="email" type="email" name="email" noValidate onChange={(e) => setFormData({...formData, email: e.target.value})}  />

      <div className="form-message">
      <label>Message</label>
      <textarea id="message" name="message" onChange={(e) => setFormData({...formData, message: e.target.value})} />
      </div>


  <div className="form-alerts">
       {errors.name && <p>! {errors.name[0]}</p>}
       {errors.phone && <p>! {errors.phone[0]}</p>}
       {errors.email && <p>! {errors.email[0]}</p>}
       {errors.message && <p>! {errors.message[0]}</p>}
</div>
       <div className="form-sent-notice">Your information was sent. I'll get back to you within 24 hours.</div>

 <div className="form-submit"> 
      <input id="form-button" className="form-button" type="submit" value="Send" />
      </div>
    </form>
  );
};

